import coreModule from './modules/core'

export default ({ store }) => {
  store.registerModule('core', coreModule({}), {
    preserveState: Boolean(store.state.core) // false at init, true on client side - for SRR (https://vuex.vuejs.org/api/#registermodule)
  })
}
